module.exports = __webpack_public_path__ + "img/08.0087e273.jpg";